import type { EventoLead } from '@app/shared';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { qk } from '../../../lib/queryKeys';

// Escucha `GET /eventos` (SSE, cookie de sesión) y, ante cualquier cambio de un
// lead, invalida la lista y la conversación de ese lead: React Query vuelve a
// pedir solo lo que cambió. EventSource reconecta solo si se corta.

const baseURL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api/v1';

export function useEventosLeads(): { conectado: boolean } {
  const queryClient = useQueryClient();
  const [conectado, setConectado] = useState(false);

  useEffect(() => {
    if (typeof EventSource === 'undefined') return undefined;
    const fuente = new EventSource(`${baseURL}/eventos`, { withCredentials: true });

    const onLead = (e: MessageEvent<string>): void => {
      try {
        const evento = JSON.parse(e.data) as EventoLead;
        void queryClient.invalidateQueries({ queryKey: qk.leads.all });
        void queryClient.invalidateQueries({ queryKey: qk.leads.mensajes(evento.leadId) });
        // ciclo-metricas-embudo-y-contenido (decisión 9): el embudo se reusa este
        // mismo stream — cualquier cambio de lead puede mover un escalón.
        void queryClient.invalidateQueries({ queryKey: ['metricas', 'embudo'] });
        // ciclo-calidad-leads: calificar un lead mueve el tablero de calidad.
        void queryClient.invalidateQueries({ queryKey: ['metricas', 'calidad'] });
      } catch {
        /* evento malformado: se ignora */
      }
    };

    fuente.addEventListener('conectado', () => {
      setConectado(true);
    });
    fuente.addEventListener('lead.actualizado', onLead as EventListener);
    fuente.onerror = () => {
      setConectado(false);
    };

    return () => {
      fuente.close();
    };
  }, [queryClient]);

  return { conectado };
}
